import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  WiredSubscriptionDetailsGQL,
  WiredSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { WiredSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { WiredSubscriptionViewComponent } from "./wired-subscription-view";

@Component({
  selector: "wired-subscription",
  templateUrl: "wired-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubscriptionPageComponent, WiredSubscriptionViewComponent],
})
export class WiredSubscriptionComponent extends GenericSubscription<
  WiredSubscriptionDetailsQuery,
  WiredSubscriptionDetails
> {
  protected query = inject(WiredSubscriptionDetailsGQL);

  protected onQuerySuccess(data: WiredSubscriptionDetailsQuery): WiredSubscriptionDetails {
    return data.wiredDetails;
  }
}
